export const selectIsCreateAnnouncementModalOpen = (state) =>
  state.communicationEntityReducer.announcement.isCreateModalOpen

export const selectIsAnnouncementRequestInProgress = (state) =>
  state.communicationEntityReducer.announcement.isRequestInProgress

export const selectAnnouncementFormData = (state) =>
  state.communicationEntityReducer.announcement.formData

export const selectAnnouncementErrors = (state) =>
  state.communicationEntityReducer.announcement.errors.fields

export const selectIsReorderAnnouncementModalOpen = (state) =>
  state.communicationEntityReducer.announcement.isReorderModalOpen

export const selectReorderAnnouncementData = (state) =>
  state.communicationEntityReducer.announcement.reorderData
